import React, { useState, useEffect, useRef, useContext } from 'react';
import logo from '../../shreeohmlogo.png';
import styles from './Usernav.module.css';
import { NavLink } from 'react-router-dom';
import { FiMenu, FiX, FiUser, FiChevronDown } from 'react-icons/fi';
import { FaShoppingCart } from 'react-icons/fa';
import { CartContext } from '../../context/Cartcontext';

const Usrnav = () => {
  const { cartItems } = useContext(CartContext);
  const cartItemCount = cartItems.length;
  const username = localStorage.getItem('username');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleLogout = () => {
  localStorage.removeItem('username');
  localStorage.removeItem('token');         
  localStorage.removeItem('userId');        
  localStorage.removeItem('userData');
  window.location.href = '/shreeohm/login'; 
};
  useEffect(() => {
    const closeDropdown = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', closeDropdown);
    return () => document.removeEventListener('mousedown', closeDropdown);
  }, []);

  const toggleDropdown = (e) => {
    e.stopPropagation(); // Prevent event bubbling
    setDropdownOpen(!dropdownOpen);
  };

  return (
   <div className={styles.unvbar}>
  <div className={styles.logoContainer}>
    <img src={logo} alt="Logo" className={styles.logo} />
    <span className={styles.brandText}>
      Shree <span className={styles.highlight}>OHM</span>
    </span>
  </div>

  <button className={styles.hamburger} onClick={() => setMenuOpen(!menuOpen)}>
    {menuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
  </button>

  <ul className={`${styles.unvLinks} ${menuOpen ? styles.active : ''}`}>
    <li>
      <NavLink
        to="/"
        end
        className={({ isActive }) => (isActive ? styles.active : '')}
      >
        All Products
      </NavLink>
    </li>
    <li>
      <NavLink
        to="/ourproducts"
        className={({ isActive }) => (isActive ? styles.active : '')}
      >
        Our Products
      </NavLink>
    </li>
    <li>
      <NavLink
        to="/supplements"
        className={({ isActive }) => (isActive ? styles.active : '')}
      >
        Supplements
      </NavLink>
    </li>
    <li className={styles.cartLink}>
      <NavLink
        to="/mycart"
        className={({ isActive }) => (isActive ? styles.active : '')}
      >
        <FaShoppingCart className={styles.cartIcon} />
        My Cart
        {cartItemCount > 0 && (
          <span className={styles.cartBadge}>{cartItemCount}</span>
        )}
      </NavLink>
    </li>
    <li>
      <NavLink
        to="/about-us"
        className={({ isActive }) => (isActive ? styles.active : '')}
      >
        About Us
      </NavLink>
    </li>
    <li>
      <NavLink
        to="/contact-us"
        className={({ isActive }) => (isActive ? styles.active : '')}
      >
        Contact Us
      </NavLink>
    </li>

    {username ? (
      <li ref={dropdownRef} className={styles.dropdownContainer}>
        <button onClick={toggleDropdown} className={styles.usernameDropdownToggle}>
          <FiUser className={styles.userIcon} />
          {username}
          <FiChevronDown
            className={`${styles.dropdownArrow} ${dropdownOpen ? styles.open : ''}`}
          />
        </button>
        <div className={`${styles.dropdownMenu} ${dropdownOpen ? styles.open : ''}`}>
          <NavLink
            to="/my-orders"
            className={({ isActive }) =>
              isActive
                ? `${styles.dropdownItem} ${styles.active}`
                : styles.dropdownItem
            }
            onClick={() => setDropdownOpen(false)}
          >
            My Orders
          </NavLink>
          <NavLink
            to="/shreeohm/settings"
            className={({ isActive }) =>
              isActive
                ? `${styles.dropdownItem} ${styles.active}`
                : styles.dropdownItem
            }
            onClick={() => setDropdownOpen(false)}
          >
            Settings
          </NavLink>
          <button
            className={`${styles.dropdownItem} ${styles.logoutBtn}`}
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>
      </li>
    ) : (
      <li>
        <NavLink
          to="/shreeohm/login"
          className={({ isActive }) => (isActive ? styles.active : '')}
        >
          Login
        </NavLink>
      </li>
    )}
  </ul>
</div>


  );
};

export default Usrnav;
